import { createSelector } from 'reselect'

export const getCloserLocationsLoading = createSelector(
  (state) => Boolean(state.geoObjects && state.geoObjects.closerLocations && state.geoObjects.closerLocations.isLoading),
  (isLoading) => isLoading
)
